<template>
  <div class="card">
    <div class="card-content">
      <article class="media">
        <div class="media-left is-size-4 has-text-right">
          {{ $t('attributes.order_process') }}
        </div>
        <div class="media-content">
          <form method="post" @submit.prevent="onSend" novalidate>
            <form-wrapper :validator="$v.form">
              <b-field grouped>
                <form-group
                  name="status"
                  :label="$t('attributes.order_process_status')"
                  label-position="on-border"
                >
                  <b-select v-model="form.status" name="status">
                    <option value="">
                      {{
                        $t('message.please_select') +
                          $t('attributes.order_process_status')
                      }}
                    </option>
                    <option
                      v-for="option in statusOptions"
                      :key="option"
                      :value="option"
                    >
                      {{ $t(`attributes.firm_order_${option}`) }}
                    </option>
                  </b-select>
                </form-group>

                <p class="control">
                  <b-button
                    type="is-info"
                    :loading="sending"
                    native-type="submit"
                  >
                    {{ $t('attributes.update') }}
                  </b-button>
                </p>
              </b-field>
            </form-wrapper>
          </form>
        </div>
      </article>

      <!-- 聯絡人 -->
      <article class="media">
        <div class="media-left is-size-4 has-text-right">
          聯絡人
        </div>
        <div class="media-content">
          <div class="mb-4">
            <p class="is-size-4">
              {{ order.username }}
            </p>
          </div>
          <div class="columns is-multiline">
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                員工編號：
                <span>{{ order.number }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                服務單位：
                <span>{{ order.department }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                聯絡電話：
                <span>{{ order.tel }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                手機號碼：
                <span>{{ order.mobile }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                Email：
                <span>{{ order.email }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                Line ID：
                <span>{{ order.lineId }}</span>
              </p>
            </div>
            <div class="column is-12 pt-1 pb-1">
              <p class="is-size-6">
                其他需求：
                <span class="has-text-weight-semibold">
                  {{ order.notes }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </article>

      <!-- 代訂機票 -->
      <article v-if="hasDemand(features.TICKETS)" class="media">
        <div class="media-left is-size-4 has-text-right">
          {{ featureName[features.TICKETS] }}
        </div>
        <div class="media-content">
          <div
            v-for="(flight, idx) of tickets.flights"
            :key="`flight-${idx}`"
            :id="`tickets-flight-${idx}`"
            class="mt-1 mb-5"
          >
            <div class="mb-3 is-size-5 has-text-weight-medium">
              <p>第{{ idx + 1 }}段航程</p>
            </div>

            <div class="columns is-multiline">
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  預定日期：
                  <span class="has-text-weight-semibold">
                    {{ formatDate(flight.departureDate) }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  出發地：
                  <span class="has-text-weight-semibold">
                    {{ flight.departure }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  目的地：
                  <span class="has-text-weight-semibold">
                    {{ flight.destination }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  航空公司：
                  <span class="has-text-weight-semibold">
                    {{ flight.airline }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  艙等：
                  <span class="has-text-weight-semibold">
                    {{ flight.flyClass }}
                  </span>
                </p>
              </div>
              <div class="column is-12 pt-1 pb-1">
                <p class="is-size-6">
                  其他需求：
                  <span class="has-text-weight-semibold">
                    {{ flight.notes }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>

      <!-- 旅遊需求 -->
      <article v-if="hasTravel()" class="media">
        <div class="media-left is-size-4 has-text-right">
          旅遊需求
        </div>
        <div class="media-content">
          <div class="mb-4">
            <p class="is-size-4"></p>
          </div>
          <div class="columns is-multiline">
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                出發日期：
                <span>{{ formatDate(travel.departureDate) }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                回程日期：
                <span>{{ formatDate(travel.returnDate) }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                出發地：
                <span>{{ travel.departure }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                目的地：
                <span>{{ travel.destination }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                艙等：
                <span>{{ travel.flyClass }}</span>
              </p>
            </div>
            <div class="column is-12 pt-1 pb-1">
              <p class="is-size-6">
                其他需求：
                <span class="has-text-weight-semibold">
                  {{ travel.notes }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </article>

      <!-- 飯店需求 -->
      <article v-if="hasDemand(features.HOTEL)" class="media">
        <div class="media-left is-size-4 has-text-right">
          飯店需求
        </div>
        <div class="media-content">
          <div class="mb-4">
            <p class="is-size-4"></p>
          </div>
          <div class="columns is-multiline">
            <div class="column is-12 pt-1 pb-1">
              <p class="is-size-6">
                計畫旅遊地點：
                <span>{{ hotel.destination }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                飯店：
                <span>{{ hotel.hotelName }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                房間人數：
                <span>{{ hotel.person }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1"></div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                入住日期：
                <span>{{ formatDate(hotel.checkinDate) }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1">
              <p class="is-size-6">
                退房日期：
                <span>{{ formatDate(hotel.checkoutDate) }}</span>
              </p>
            </div>
            <div class="column is-4 pt-1 pb-1"></div>
            <div class="column is-4 pt-1 pb-1">
              <p
                class="is-size-6"
                style="display: flex; justify-content: start;"
              >
                護照影本：
                <span class="pl-1">
                  <a :href="hotel.passport" target="_blank">
                    <img
                      :src="hotel.passport"
                      alt="passport"
                      style="height: 60px;"
                    />
                  </a>
                </span>
              </p>
            </div>
            <div class="column is-8 pt-1 pb-1">
              <p class="is-size-6">
                床位：
                <span>{{ hotel.bed }}</span>
              </p>
            </div>
            <div class="column is-12 pt-1 pb-1">
              <p class="is-size-6">
                其他需求：
                <span class="has-text-weight-semibold">
                  {{ hotel.notes }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </article>

      <!-- 其他需求 -->
      <article v-if="hasDemand(features.OTHER)" class="media">
        <div class="media-left is-size-4 has-text-right">
          其他需求
        </div>
        <div class="media-content">
          <div class="mb-4">
            <p class="is-size-4"></p>
          </div>
          <div class="columns is-multiline">
            <div class="column is-12 pt-1 pb-1">
              <p class="is-size-6">
                代辦資料：
                <span>{{ other.agent.join(',') }}</span>
              </p>
            </div>
            <div class="column is-12 pt-1 pb-1">
              <p class="is-size-6">
                其他需求：
                <span class="has-text-weight-semibold">
                  {{ other.notes }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </article>

      <!-- 旅客資料 -->
      <article v-if="hasPersons()" class="media">
        <div class="media-left is-size-4 has-text-right">
          旅客資料
        </div>
        <div class="media-content">
          <div
            v-for="(person, idx) of persons"
            :key="`flight-${idx}`"
            :id="`tickets-flight-${idx}`"
            class="mt-1 mb-5"
          >
            <div class="mb-3 is-size-5 has-text-weight-medium">
              <p>第{{ idx + 1 }}位旅客</p>
            </div>

            <div class="columns is-multiline">
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  中文姓名：
                  <span class="has-text-weight-semibold">
                    {{ person.username }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  出生日期：
                  <span class="has-text-weight-semibold">
                    {{ formatDate(person.birthDate) }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  英文姓：
                  <span class="has-text-weight-semibold">
                    {{ person.firstName }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  英文名：
                  <span class="has-text-weight-semibold">
                    {{ person.lastName }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  身份證/護照：
                  <span class="has-text-weight-semibold">
                    {{ person.identity }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p class="is-size-6">
                  性別：
                  <span class="has-text-weight-semibold">
                    {{ person.gender }}
                  </span>
                </p>
              </div>
              <div class="column is-4 pt-1 pb-1">
                <p
                  class="is-size-6"
                  style="display: flex; justify-content: start;"
                >
                  護照影本：
                  <span class="pl-1">
                    <a :href="person.passport" target="_blank">
                      <img
                        :src="person.passport"
                        alt="passport"
                        style="height: 60px;"
                      />
                    </a>
                  </span>
                </p>
              </div>
              <div class="column is-12 pt-1 pb-1">
                <p class="is-size-6">
                  其他需求：
                  <span class="has-text-weight-semibold">
                    {{ person.notes }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { FIRM_COLLABORATE_ORDERS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'FirmOrderDetail',

  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    // eslint-disable-next-line no-console
    console.log(this.order)

    return {
      sending: false,
      statusOptions: ['pending', 'processing', 'complete'],

      features: {
        TICKETS: 'tickets',
        INTERNAL: 'internal',
        FREE: 'free',
        GROUP: 'group',
        HOTEL: 'hotel',
        OTHER: 'other'
      },
      featureName: {
        tickets: '代訂機栗',
        internal: '國內旅遊',
        free: '機＋酒自由行',
        group: '團體旅遊',
        hotel: '代訂飯店',
        other: '其他'
      },

      form: {
        status: this.order.status
      },

      tickets: JSON.parse(this.order.tickets),
      travel: JSON.parse(this.order.travel),
      hotel: JSON.parse(this.order.hotel),
      other: JSON.parse(this.order.other),
      persons: JSON.parse(this.order.persons)
    }
  },
  validations: {
    form: {
      status: { required }
    }
  },
  methods: {
    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.updateStatus()
    },
    async updateStatus() {
      const api = `${FIRM_COLLABORATE_ORDERS_API}/${this.order.id}/process`
      try {
        this.sending = true
        const res = await this.axios.post(api, { status: this.form.status })
        const order = res.data.data

        notifyService.success(this.$t('attributes.update_succeed'))

        this.$emit('updated', order)
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    hasDemand(type) {
      return this.order.demand.includes(type)
    },
    hasTravel() {
      return (
        this.hasDemand(this.features.FREE) ||
        this.hasDemand(this.features.GROUP) ||
        this.hasDemand(this.features.INTERNAL)
      )
    },
    hasPersons() {
      return (
        this.hasDemand(this.features.TICKETS) ||
        this.hasDemand(this.features.FREE) ||
        this.hasDemand(this.features.GROUP) ||
        this.hasDemand(this.features.INTERNAL)
      )
    }
  }
}
</script>
